import "./components/animation";
import "./components/vanta.globe.min.js";
import "./components/background";
import "./components/accordion-steps";
import "./components/accordion-faq";
import "./components/input-file";
import "./components/order-form";
import "./components/placeholders";
